
    import '/opt/buildhome/repo/packages/x/docs/x-markdown/data-display.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-markdown-data-display-demo-mermaid","docs-x-markdown-data-display-demo-infographic"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/x-markdown/data-display.zh-CN.md?type=demo')
};